export default __webpack_public_path__ + "static/media/bg_desc_big_style.c71af3d9.jpg";